/**
动态渲染组件

 */

export default {
  name: 'sideItemDynamic',
  props: {
    componentName: {
      type: String,
    },
    componentProps: {
      type: Object,
      default: () => {},
    },
    watchInputHandle: {
      type: Object,
      default: () => {},
    },
    specialState: {
      //自定义的store初始状态
      type: Object,
      default: () => ({}),
    },
    specialMutations: {
      //自定义的store初始Mutations
      type: Object,
      default: () => ({}),
    },
    specialActions: {
      //自定义的store初始Actions
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // data: this.value
    }
  },
  beforeDestroy() {
    this.data = null
  },

  methods: {},
  render(h) {
    this.componentProps.onSide = true
    this.componentProps.watchInputHandle = this.watchInputHandle
    this.componentProps.specialState = this.specialState
    this.componentProps.specialMutations = this.specialMutations
    this.componentProps.specialActions = this.specialActions
    var vNodeFn = h(this.componentName, {
      ref: 'sideItemDynamic',
      props: this.componentProps,
      on: {
        'side-item-dynamic-on-ok': () => {
          this.$emit('on-ok')
        },
        'side-item-dynamic-on-modify': () => {
          this.$emit('on-modify')
        },
        'on-clear-side-modify': () => {
          this.$emit('on-modify-clear')
        },
        'side-item-dynamic-on-ok-and-continue': () => {
          this.$emit('on-ok-and-continue')
        },
      },
    })
    return vNodeFn
  },
}
